import axios from 'axios';

import {
    FETCH_SALES_LISTINGS,
    FETCH_SALES_LISTINGS_SUCCESS,
    FETCH_SALES_LISTINGS_FAIL,
    CREATE_SALES_LISTING,
    CREATE_SALES_LISTING_SUCCESS,
    CREATE_SALES_LISTING_FAIL,
    DELETE_SALES_LISTING,
    DELETE_SALES_LISTING_SUCCESS,
    DELETE_SALES_LISTING_FAIL
} from './_types';

import { API_URL } from '../../helpers/variables';
import { errorHandler } from '../../helpers/alerts';
import { authConfig } from '../../helpers/authConfig';

export function fetchSalesListings(params) {
    return async (dispatch) => {
        dispatch({ type: FETCH_SALES_LISTINGS });

        const config = {
            headers: authConfig(),
            params
        };

        try {
            const response = await axios.get(
                API_URL + '/sales-listings',
                config
            );

            dispatch({
                type: FETCH_SALES_LISTINGS_SUCCESS,
                payload: { ...response }
            });
        } catch (error) {
            dispatch({ type: FETCH_SALES_LISTINGS_FAIL });
            errorHandler(dispatch, error.response);
        }
    };
}

export function createSalesListing(data) {
    return async (dispatch) => {
        dispatch({ type: CREATE_SALES_LISTING });

        const config = {
            headers: authConfig()
        };

        try {
            const response = await axios.post(
                API_URL + '/sales-listings',
                data,
                config
            );

            dispatch({
                type: CREATE_SALES_LISTING_SUCCESS,
                payload: { ...response }
            });
        } catch (error) {
            dispatch({ type: CREATE_SALES_LISTING_FAIL });
            errorHandler(dispatch, error.response);
        }
    };
}

export function deleteSalesListing({ id }) {
    return async (dispatch) => {
        dispatch({ type: DELETE_SALES_LISTING });

        const config = {
            headers: authConfig()
        };

        try {
            const response = await axios.delete(
                `${API_URL}/sales-listings/${id}`,
                config
            );

            dispatch({
                type: DELETE_SALES_LISTING_SUCCESS,
                payload: { ...response }
            });
        } catch (error) {
            dispatch({ type: DELETE_SALES_LISTING_FAIL });
            errorHandler(dispatch, error.response);
        }
    };
}
